var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 33.347,
    viewBox: "0 0 50 33.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-forward",
    "data-name": "Icon ionic-ios-arrow-round-forward",
    d: "M39.761,11.89a2.269,2.269,0,0,0-.017,3.2L50.3,25.662H10.115a2.258,2.258,0,0,0,0,4.515h40.17L39.726,40.754a2.286,2.286,0,0,0,.017,3.2,2.248,2.248,0,0,0,3.178-.017L57.232,29.518h0a2.535,2.535,0,0,0,.469-.712,2.155,2.155,0,0,0,.174-.868,2.264,2.264,0,0,0-.643-1.58L42.922,11.942A2.212,2.212,0,0,0,39.761,11.89Z",
    transform: "translate(-7.875 -11.252)",
    fill: "#610D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.5bd16fa23731783c11861c0f5bbf7827.svg";
export { ForwardRef as ReactComponent };